import { format } from 'date-fns';
import { Notification, NotificationIds } from 'modules/notificationCenter/types';
import { ReadMail, UnreadMail } from 'ui/icons/action';
import { getTextOnly } from 'utils/stringHelpers';
import { STATUS_OPTIONS } from '../../constants';
import {
  Description,
  StatusIconWrapper,
  PositionedCounterBadge,
  TitleLink,
  MarkButton,
  OccurrenceDate,
  StyledCard,
  CategoryTag,
  Title,
} from './ModernizedNotificationCard.styled';
import { StatusIcon } from './StatusIcon';

type Props = {
  /** Notification being displayed */
  notification: Notification;
  /** Whether or not a notification has been read yet */
  status: string;
  updateNotifications: (notificationData: NotificationIds[], isAllReadRequest?: boolean) => void;
};

export const ModernizedNotificationCard = ({
  notification,
  status,
  updateNotifications,
}: Props) => {
  const { id, createdAt, occurrenceCount, category, level, actionUrlOpt, title, description } =
    notification;

  const oppositeStatus =
    status === STATUS_OPTIONS.read ? STATUS_OPTIONS.unread : STATUS_OPTIONS.read;
  const titleText = title || '[No title]';
  const descriptionText = getTextOnly(description);
  const occurrenceDate = format(new Date(createdAt), 'MMM do yyyy, h:mmaaa');

  return (
    <StyledCard data-test="notification">
      {actionUrlOpt ? (
        <TitleLink useReactRouter href={actionUrlOpt}>
          {titleText}
        </TitleLink>
      ) : (
        <Title>{titleText}</Title>
      )}
      {occurrenceCount > 1 && (
        <PositionedCounterBadge level={level}>{occurrenceCount}</PositionedCounterBadge>
      )}
      <StatusIconWrapper>
        <StatusIcon status={level} />
      </StatusIconWrapper>
      <Description>{descriptionText}</Description>
      <OccurrenceDate>{occurrenceDate}</OccurrenceDate>
      <CategoryTag>{category}</CategoryTag>
      <MarkButton
        data-test="notification-action-button"
        onClick={() => updateNotifications([{ notificationId: id, status: oppositeStatus }])}
      >
        {status === STATUS_OPTIONS.read ? <UnreadMail /> : <ReadMail />}
        <span>Mark as {oppositeStatus}</span>
      </MarkButton>
    </StyledCard>
  );
};
